import { AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { getTraceparent } from '@frete.com/tracking-sdk';
import { navigate } from '~routes';
import { ONBOARDING_TOKEN } from '~constants/localStorageIndexes';

export const withTraceparent = (config: InternalAxiosRequestConfig) => {
  config.headers.traceparent = getTraceparent();
  return config;
};

export const handleFulfilled = (success: AxiosResponse) => {
  return success;
};

export const handleRejected = (error: AxiosError) => {
  if (error?.response?.status < 400 || error?.response?.status >= 500)
    navigate('/erro/envio-dados');

  return Promise.reject(error);
};

export const handleClosedOnboardingRequest = (request) => {
  const token = localStorage.getItem(ONBOARDING_TOKEN);

  if (!token) return request;

  return {
    ...request,
    headers: {
      ...request.headers,
      Authorization: `Bearer ${token}`,
    },
  };
};

export const handleClosedOnboardingError = (error: AxiosError) => {
  if (error?.response?.status <= 400 || error?.response?.status >= 500)
    navigate('/');

  return Promise.reject(error);
};
